import React, { useEffect, useState } from "react";

import HistoryPointCorrespondencePopup from "./Point Correaspondance Popup/HistoryPointCorrespondence";
import { getTelemetryHistory } from "./HistoryUtils";

function getTelemetryPacketType(packet: Record<string, number | string>) {
  if (packet?.["OT"]) {
    return "OPERATION";
  }
  if (packet?.["NWKR"]) {
    return "DETECTION";
  }
  if (packet?.["S1GAP"]) {
    return "GAP";
  }

  return null;
}

type ParsedDataType = {
  GAP: Record<string, number | string>;
  DETECTION: Record<string, number | string>;
};

function getInitialData(raw_data: Record<string, number | string>): ParsedDataType {
  const packet_type = getTelemetryPacketType(raw_data);

  if (!packet_type || packet_type === "OPERATION") return { GAP: {}, DETECTION: {} };
  return { GAP: {}, DETECTION: {}, [packet_type]: raw_data };
}

const MS_PER_MINUTE = 60 * 1000;

type HistoryPacket = { data: [{ dateTime: number; subGear: string; values: Record<string, number | string> }] };

interface Props {
  open: boolean;
  onClose: () => void;
  data: Record<string, number | string>;
  deviceId: string;
}

const PointCorrespondenceWrapper: React.FC<Props> = ({ open, onClose, data, deviceId }) => {
  const [parsedData, setParsedData] = useState<ParsedDataType>(getInitialData(data));
  const packet_time = data?.lastActivityTime as number | null;
  const initial_packet_type = getTelemetryPacketType(data);
  const rem_packet_type = initial_packet_type === "GAP" ? "DETECTION" : "GAP";

  async function getClosestHistoryPacket(params: any, signal: AbortSignal) {
    if (!packet_time) return;
    const _raw_response = await getTelemetryHistory(params, signal);
    const _data = (_raw_response?.data?.data?.content ?? []) as HistoryPacket[];

    let closest_packet = _data[0];

    for (const _packet of _data) {
      const current_time_diff = Math.abs(closest_packet.data[0].dateTime - packet_time);
      const packet_time_diff = Math.abs(_packet.data[0].dateTime - packet_time);
      if (packet_time_diff < current_time_diff) {
        closest_packet = _packet;
      }
    }
    setParsedData((state) => ({
      ...state,
      [rem_packet_type]: { ...closest_packet.data[0].values, lastActivityTime: closest_packet.data[0].dateTime },
    }));
    return _data;
  }

  useEffect(() => {
    if (!open || !initial_packet_type || initial_packet_type === "OPERATION" || !packet_time) return;
    const abortController = new AbortController();
    const params = {
      page: 1,
      pageSize: 20,
      isModelView: true,
      deviceId,
      subtype: rem_packet_type,
      startTs: packet_time - MS_PER_MINUTE * 2,
      endTs: packet_time + MS_PER_MINUTE * 2,
    };
    getClosestHistoryPacket(params, abortController.signal);

    return () => {
      abortController.abort();
    };
  }, [open]);

  if (!open) return <></>;

  return <HistoryPointCorrespondencePopup open={true} dataPacket={parsedData} onClose={onClose} />;
};

export default PointCorrespondenceWrapper;
